import { Card } from '@appd/uik';

export type BusinessJourneyLayout = 'horizontal' | 'vertical';

export const stroke = 'var(--brand-accent-icon)';
export const strokeLinecap = 'butt';
export const strokeLinejoin = 'round';
export const strokeWidth = 2;
export const gapBetweenNodes = 60;
export const defaultNodeHeight = 128;
export const defaultNodeWidth = 420;

export interface HierarchyData {
  id: string;
  parentId?: string;
}

export type TitleTag = NonNullable<Card.Props['titleTag']>;

export type TitleTagType = TitleTag['type'];

export type HealthType = 'HEALTHY' | 'WARNING' | 'CRITICAL' | 'UNKNOWN';

export interface MilestoneData {
  id: string;
  name: string;
  count: number;
  durationFromPrevMilestone?: number;
  conversionRateFromPrevMilestone?: number;
  conversionRateFromFirstMilestone?: number;
  health: HealthType;
  isTransitionMilestone?: boolean;
}

export type ValueWithComparison = {
  current: number;
  previous: number;
};

export interface NodeData extends MilestoneData, HierarchyData {}

export interface BusinessJourneyData {
  journeyHealth: HealthType;
  journeyDuration: ValueWithComparison;
  conversionRate: ValueWithComparison;
  criticalMilestones: ValueWithComparison;
  totalJourneys: number;
  completedJourneys: number;
  inflightJourneys: number;
  percentile: number;
  milestones: MilestoneData[];
}
